import React from 'react';
import { ExpandArrowIcon } from '../../icons';
export var MuiAccordionSummary = {
    expandIcon: React.createElement(ExpandArrowIcon, { color: "inherit", size: "16px" }),
};
//# sourceMappingURL=MuiAccordionSummary.js.map